export default async (context:any, payload:any) => {
    const setAttribute = payload.oneLni.storeUtils.setAttribute;
    const moduleId = context.getters.moduleId;
    setAttribute(context, moduleId, 'sectionLoading', true);

    await context.dispatch('clear', payload);

    const item = context.rootState.appState.jobPlan[payload.index];
    context.commit('appState/SET_EDIT_INDEX', payload.index, { root: true });

    const categories = ['task', 'location', 'tool', 'variation'];
    for (let i = 0; i < categories.length; i++) {
        const key = categories[i];
        const value = item[key].value;
        context.commit(`${moduleId}/SET_PATH_PARAM`, {
            key,
            value,
        }, {
            root: true,
        });
    }

    // Fetch job that is selected/being edited
    await context.dispatch('call', payload, { root: true });

    const appState = context.rootState.appState;
    // Set category select options and values
    for (let i = 0; i < categories.length; i++) {
        const key = categories[i];
        const value = item[key].value;
        setAttribute(context, `${moduleId}_${key}`, 'options', appState.data[`${key}s`]); // Plural
        setAttribute(context, `${moduleId}_${key}`, 'value', value);

        if (key !== 'task') {
            setAttribute(context, `${moduleId}_${key}-collapse`, 'visible', true);
        }
    }

    setAttribute(context, `${moduleId}_hours`, 'value', item.hours);
    setAttribute(context, `${moduleId}_minutes`, 'value', item.minutes);
    setAttribute(context, `${moduleId}_quantity`, 'value', item.quantity);

    setAttribute(context, moduleId, 'sectionLoading', false);
};